import type { IconProps } from '@iconify/react';
import type { Theme, SxProps } from '@mui/material/styles';

import { forwardRef } from 'react';
import { Icon, disableCache } from '@iconify/react';
import { mergeClasses } from 'minimal-shared/utils';

import { styled } from '@mui/material/styles';

import { iconifyClasses } from './classes';

// ----------------------------------------------------------------------

export type IconifyProps = React.ComponentProps<typeof IconRoot> & IconProps;

export const Iconify = forwardRef<SVGSVGElement, IconifyProps>((props, ref) => {
  const { className, width = 20, sx, ...other } = props;

  const rootClassName = mergeClasses([iconifyClasses.root, className]);
  const rootSx: SxProps<Theme> = [
    {
      width,
      height: width,
      flexShrink: 0,
      display: 'inline-flex',
    },
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  // @iconify/react shows children until the icon loads; its fallback prop leaks onto the <svg>.
  return (
    <IconRoot ssr ref={ref} className={rootClassName} sx={rootSx} {...other}>
      <IconPlaceholder className={rootClassName} sx={rootSx} />
    </IconRoot>
  );
});

// https://iconify.design/docs/iconify-icon/disable-cache.html
disableCache('local');

// ----------------------------------------------------------------------

const IconRoot = styled(Icon)``;

const IconPlaceholder = styled('span')``;
